import { ContentBlockCopySectionCentered } from '@dfh-corp-sites/ui'
import React from 'react'

import { Maybe, SanityContact } from '../../../groq/sanity-dispensaries/types'

type Props = {
  practice?: Maybe<SanityContact['practice']>
}

const Approach = ({ practice }: Props) => {
  if (!practice?.approach) {
    return null
  }
  return (
    <ContentBlockCopySectionCentered
      title="Our approach to care"
      content={practice?.approach ?? ''}
    />
  )
}

export { Approach }
